/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { User } from "react-feather";
import { useDispatch } from 'react-redux'
import styled, { css } from "styled-components";
import ReservationAction from 'redux/reservation/actions'
import Button from "../../../styled/Button";
import Text from "../../../styled/Text";
import { Center } from "../../../styled/Block";
import useToggle from "../../../common/useToggle";
import HeaderDropdown from "./HeaderDropdown";
import SignButton from "../../../common/SignButton";
import ProfileModal from "../ProfileModal";
import Logout, { LogoutModal } from "../Logout/Logout";

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, 0.5)`
  }
  return null;
}

const cssHeaderAbs = css`
  background-color: transparent;
  z-index: 50;
`;

const cssHeaderNorm = css`
  background-color: ${({ theme }) => theme.colors.primaryBg};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  position: sticky;
  top: 0;
  z-index: 50;
`;

const StylHeader = styled.header`
  ${({ isTransparent }) => (isTransparent ? cssHeaderAbs : cssHeaderNorm)};
  width: 100%;
`;

const StylNav = styled.nav`
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 15px;
`;

const StylUser = styled(Center)`
  width: 40px;
  height: 40px;
  ${({ themeColor, isTransparent }) =>
    isTransparent
      ? css`
          background: ${hexToRgb(themeColor)};
        `
      : css`
          background: ${hexToRgb(themeColor)};
        `};
  color: #fff;
  border-radius: 50%;
`;

const StylSigninTxt = styled(Button)`
  background: ${({ themeColor }) => hexToRgb(themeColor)};
  padding: 0px 10px;
  border-radius: 10px;
`;

const ProfileBtn = ({ businessID, firstName, firstForm }) => {
  const dispatch = useDispatch()
  const showProfile = () => {
    dispatch({
      type: ReservationAction.SET_STATE,
      payload: {
        profilePopUp: true,
        isPopup: true,
      },
    })
  }
  return (
    <li>
      {firstForm && (
        <>
          <a href="javascript:void(0)" onClick={showProfile} rel="noopener noreferrer">{firstName}</a>
          <ProfileModal business_id={businessID} />
        </>
      )}
      {!firstForm && (
        <a href="javascript:void(0)" rel="noopener noreferrer">{firstName}</a>
      )}
    </li>
  );
};

const LogoutBtn = ({ themeColor }) => {
  const { toggle, onTrue, onFalse } = useToggle();
  const [show, set] = useState(false);

  return (
    <li>
      <a href="javascript:void(0)" onClick={onTrue} rel="noopener noreferrer">Logout</a>
      {toggle && (
        <LogoutModal
          onLogout={() => {
            onFalse();
            set(true);
          }}
          isOpen
          close={onFalse}
          themeColor={themeColor}
        />
      )}
      {show && <Logout />}
    </li>
  );
};

const UserRound = ({ businessID, firstName, isTransparent, themeColor, firstForm }) => {

  return (
    <HeaderDropdown
      btn={
        <StylUser isTransparent={isTransparent} themeColor={themeColor}>
          <User size={20} />
        </StylUser>
      }
    >
      <ul>
        <ProfileBtn businessID={businessID} firstName={firstName} firstForm={firstForm} />
        <LogoutBtn themeColor={themeColor} />
      </ul>
    </HeaderDropdown>
  );
};

const Header = ({
  isTransparent,
  accessToken,
  firstName,
  themeColor,
  maxWidth,
  businessID,
  loading,
  singInPopUp,
  firstForm,
}) => {
  return (
    <StylHeader isTransparent={isTransparent}>
      <StylNav maxWidth={maxWidth}>
        <div>
          &nbsp;
        </div>
        <SignButton
          themeColor={themeColor}
          businessID={businessID}
          loading={loading}
          singInPopUp={singInPopUp}
          render={({ showSignIn }) => {
            return (
              <div>
                {accessToken ? (
                  <UserRound businessID={businessID} firstName={firstName} isTransparent={isTransparent} themeColor={themeColor} firstForm={firstForm} />
                ) : (
                  <StylSigninTxt isTransparent={isTransparent} onClick={showSignIn} themeColor={themeColor}>
                    <Text color={isTransparent ? "white" : "restaurant"} style={{ color: "#fff" }}>
                      Sign In
                    </Text>
                  </StylSigninTxt>
                )}
              </div>
            );
          }}
        />
      </StylNav>
    </StylHeader>
  );
};

export default Header;
